import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

const limboDialog = [
  new Dialog(
    "You attempt to limbo and accidentally break your back!",
    require("@/images/Injured_Back.png"),
    require("@/audio/loseitem.mp3")
  ),
];

export class CruiseShipInterior extends Scene {
  async init() {
    this.image = require("@/images/Ship_Deck_Empty.png");
    this.title = "Aboard Cruise Ship";
    this.audio = null;
    this.description = "";
  }

  get options(): any[] {
    return [
      new Choice("Approach Buffet Table", async () =>
        await this.navigate(scenes.BuffetTable())
      ),
      new Choice("Attempt the Limbo Pole", async () => {
        await this.dialogRunner(limboDialog)
        await this.navigate(scenes.EmergencyRoom())
      }),
      new Choice("Leave", async () => await this.navigate(scenes.CruiseShipExterior())),
    ];
  }
}

export default new CruiseShipInterior();
